import { render } from "./Editor.vue?vue&type=template&id=5e3cb21a&ts=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__